import { Route, Routes } from 'react-router-dom';
import { useLoggedIn } from '@/hooks/useProfile';
import { PrivateRoutes } from './private.routes';
import { safeLazy } from '@/components/SafeLazy/SafeLazy';
import { MetaChange } from './MetaChange';

const BasicInfo = safeLazy(() => import('@/pages/CompanyPage/Product/BasicInfo'));

const Search = safeLazy(() => import('@/components/Dashboard/ContextPages/Search/Search'));
const CompanyPage = safeLazy(() => import('@/pages/CompanyPage/Company/CompanyPage'));
const BatchProductPage = safeLazy(() => import('@/pages/CompanyPage/Product/CompanyProduct'));
const ConfirmedPayment = safeLazy(
  () => import('@/pages/CompanyPage/Product/Marketplace/ConfirmedPayment')
);

const SignIn = safeLazy(() => import('@/components/Auth/SignIn'));
const OrderConfirmation = safeLazy(
  () => import('@/components/Dashboard/Pages/Payments/OrderConfirmation')
);

const ChangePassword = safeLazy(() => import('@/components/Auth/ChangePassword'));

const PublicScanner = safeLazy(
  () => import('@/components/Dashboard/Pages/QRCodeScanner/PublicScanner')
);

const SignUp = safeLazy(() => import('@/components/Auth/SignUp'));

const AuthResult = safeLazy(() => import('@/components/Auth/AuthResult'));

const Item = safeLazy(() => import('@/pages/Item/Item'));

const StatusPage = safeLazy(() => import('../pages/StatusPage/StatusPage'));

const SeedsbitView = safeLazy(
  () => import('@/components/Dashboard/ContextPages/Views/SeedsbitView/SeedsbitView')
);

const Home = safeLazy(() => import('../pages/Home/Home'));

export const PublicRoutes = () => {
  const isSignIn = useLoggedIn();

  return (
    <>
      <Routes>
        <Route key="/" index path="/" element={<Home />} />,
        <Route path="/scan" element={<PublicScanner />} />
        <Route path="/search/:query/:page" element={<Search />} />
        <Route path="/confirm-payment" element={<ConfirmedPayment />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/recover" element={<ChangePassword />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/verifyemail" element={<AuthResult />} />
        <Route path="/trace-view/:id/" element={<SeedsbitView />} />
        <Route key={'/company/:id'} path="/company/:id/" element={<CompanyPage />} />
        <Route key="/lot/:id" path="/lot/:id/" element={<BatchProductPage />} />
        <Route key="/dl/:id" path="/dl/:id/" element={<BasicInfo />} />
        <Route key="/products/:id" path="/products/:id/" element={<BatchProductPage />} />
        <Route path="/page/:id/:version" element={<Item />} />
        <Route path="/page/:id/" element={<Item />} />
        <Route path="/404" element={<StatusPage type="404" />} />
        <Route path="/503" element={<StatusPage type="503" />} />
        {isSignIn && <Route path="*" element={<PrivateRoutes />} />}
        <Route path="*" element={<StatusPage type="404" />} />
      </Routes>
      <MetaChange />
    </>
  );
};
